"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOrganisationResponseStruct = void 0;
const superstruct_1 = require("superstruct");
exports.CreateOrganisationResponseStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
});
//# sourceMappingURL=CreateOrganisationResponse.js.map